import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { mapValidationFieldsToClassName } from '../../forms/inputValidations';


const ChapterSelector = props => (
  <div className="chapter-selector-container">
    <label htmlFor="chapter-selector">Chapters: </label>
    <div className="chapter-selector">
      <Select
        className={props.className}
        name="form-field-name"
        options={chapterOptions}
        multi
        simpleValue
        value={props.pacerSearchResults.getIn(['filters', 'chapter']) || 'one'}
        placeholder="Select..."
        onChange={chapter => props.onChange({ chapter: chapter || '' })}
      />
    </div>
  </div>
);


export default connect(state => mapValidationFieldsToClassName(state, 'chapter'))(ChapterSelector);

// TODO move this to separate file (or maybe it initializes from service?)
const chapterOptions = [
  { value: '7', label: '7' },
  { value: '9', label: '9' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '15', label: '15' },
  { value: '304', label: '304' },
];



// WEBPACK FOOTER //
// ./src/components/search/FormElements/chapterSelector/ChapterSelector.js